import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import * as moment from 'moment';
import { SelectItem } from 'primeng/primeng';
import { CalendarTranslateService } from '../../../../modules/UIKit/services/calendarTranslate.service';
import { CampaignService } from '../../../../services/campaign/campaign.service';
import { Campaign } from '../campaign';
import { CampaignStep } from '../campaign-step';


@Component({
  selector: 'campaign-step-2',
  templateUrl: 'campaign-step-2.html',
  styleUrls: ['./campaign-step-2.css'],
  encapsulation: ViewEncapsulation.None
})
export class CampaignStep2Component implements CampaignStep {

  @Input() campaign: Campaign;
  @Input() savedPriorities: object[];

  @Output() prioritiesChanged: EventEmitter<any> = new EventEmitter();

  private emissionDuration: number;
  private redemptionDuration: number;
  public calendarTranslate: any;
  private today: Date = new Date();
  private types: Array<any> = [];
  private priorities: Array<SelectItem> = [];
  private bypasses: Array<any> = [];
  public channels: Array<any> = [];
  public errors: Array<any> = [];
  public channelPriorities: object[] = [];
  private priorityList: any[] = [];
  public flagAllSelectedChannels: number;


  constructor(private campaignService: CampaignService, public calendarService: CalendarTranslateService)
  {
    this.calendarService.pCalendar.subscribe(res => {
      this.calendarTranslate = res;
    });
  }

  ngOnInit()
  {
    if(typeof this.campaign.getCreateCampaignDefaultFormData !== 'undefined') {
      this.loadFormData();
      return;
    }

    this.campaignService.getCreateCampaignDefaultFormData(this.campaign.targetId).subscribe(res => {
      this.campaign.getCreateCampaignDefaultFormData = res;
      this.loadFormData();
    });

    this.campaignService.getChannelPriorities(this.campaign.targetId).subscribe(
      res => {
        res.map( priority => {
          this.channelPriorities.push({
            name: priority.descrizione_canale,
            value: priority.codice_canale
          });
        });
        this.flagAllSelectedChannels = res[0].flag_tutti_canali;
      },
      err => console.error(err),
      () => {
        this.priorityList = this.channelPriorities;
        this.prioritiesChanged.emit(this.channelPriorities);
      }
    );

  }

  loadFormData()
  {
    let res;

    res = this.campaign.getCreateCampaignFormData;
    this.types = res.campaignMasterModel.campaignTypeModel;
    this.bypasses = res.campaignMasterModel.bypassCustomerRulesModel;
    this.channels = res.channelModel;
    for(let i = 0; i < res.campaignMasterModel.campaignPriorityModel.length; i++) {
      const priority = res.campaignMasterModel.campaignPriorityModel[i];
      this.priorities.push({ label: priority.name, value: priority.value });
    }

    if (this.types.length > 0) {
      // fix campaign types
      this.types[0].value = Campaign.TYPE_ONE_SHOT;
      this.types[1].value = Campaign.TYPE_RECURRING;
    }

    res = this.campaign.getCreateCampaignDefaultFormData;
    this.emissionDuration = parseInt(res.campaignChannelPrefillModel.emissionDuration);
    this.redemptionDuration = parseInt(res.campaignChannelPrefillModel.redemptionDuration);
    this.campaign.type = this.campaign.type || parseInt(res.campaignMasterPrefillModel.type);
    this.campaign.priority = this.campaign.priority || parseInt(res.campaignMasterPrefillModel.priority);
    this.campaign.bypass = this.campaign.bypass || parseInt(res.campaignMasterPrefillModel.bypass);
    this.campaign.channels = this.campaign.channels || [parseInt(res.campaignChannelPrefillModel.channel)];

    if(typeof this.campaign.flagOpenRedemptionPeriod === 'undefined') {
      this.campaign.flagOpenRedemptionPeriod = res.campaignChannelPrefillModel.isRedemptionPeriodOpen == "1";
    }
    if(typeof this.campaign.flagAllSelectedChannels === 'undefined') {
      this.campaign.flagAllSelectedChannels = res.campaignChannelPrefillModel.flagAllSelectedChannels == "1";
    }
    if(typeof this.campaign.flagOnlyCardHolder === 'undefined') {
      this.campaign.flagOnlyCardHolder = res.campaignChannelPrefillModel.flagOnlyCardHolder == "1";
    }
    if(typeof this.campaign.flagOnlyLoyaltyCard === 'undefined') {
      this.campaign.flagOnlyLoyaltyCard = res.campaignChannelPrefillModel.flagOnlyLoyaltyCard == "1";
    }
  }

  emissionDateSelect()
  {
    this.campaign.emissionEndDate = moment(this.campaign.emissionStartDate).add(this.emissionDuration, 'days').toDate();
    this.campaign.redemptionStartDate = moment(this.campaign.emissionEndDate).add(1, 'days').toDate();
    this.redemptionDateSelect();
  }

  redemptionDateSelect()
  {
    this.campaign.redemptionEndDate = moment(this.campaign.redemptionStartDate).add(this.redemptionDuration, 'days').toDate();
    this.checkDates();
  }

  checkDates()
  {
    this.errors = [];
    const now = new Date();

    if(moment(this.campaign.emissionStartDate).isBefore(now, 'day')) {
      this.errors.push({
        severity: 'error',
        summary: 'Error',
        detail: 'Emission Start Date must be at least today'
      });
    }

    if(moment(this.campaign.emissionEndDate).isBefore(this.campaign.emissionStartDate, 'day')) {
      this.errors.push({
        severity: 'error',
        summary: 'Error',
        detail: 'Emission End Date must be same or after Emission Start Date'
      });
    }

    if(moment(this.campaign.redemptionStartDate).isBefore(this.campaign.emissionStartDate, 'day')) {
      this.errors.push({
        severity: 'error',
        summary: 'Error',
        detail: 'Redemption Start Date must be same or after Emission Start Date'
      });
    }

    if(moment(this.campaign.redemptionEndDate).isBefore(this.campaign.emissionEndDate, 'day')) {
      this.errors.push({
        severity: 'error',
        summary: 'Error',
        detail: 'Redemption End Date must be same or after Emission End Date'
      });
    }
  }

  priorityChangedHandler(priorityList: object[]) {
    if (priorityList.length > 0) {
      this.priorityList = priorityList; // importo lista priorità dal child drag-and-drop-list;
      this.prioritiesChanged.emit(this.priorityList);
    } else {
      this.priorityList = this.savedPriorities; // per non perdere la lista delle priorità quando torno indietro da step 3
    }
  }

  public isStepCompleted()
  {
    this.flagAllSelectedChannels ? this.campaign.flagAllSelectedChannels = true : this.campaign.flagAllSelectedChannels = false;
    return (
      this.priorityList.length > 0 &&
      typeof this.campaign.type !== 'undefined' &&
      typeof this.campaign.priority !== 'undefined' &&
      typeof this.campaign.bypass !== 'undefined' &&

      typeof this.campaign.channels !== 'undefined' && this.campaign.channels.length > 0 &&
      typeof this.campaign.emissionStartDate !== 'undefined' &&
      typeof this.campaign.emissionEndDate !== 'undefined' &&
      typeof this.campaign.redemptionStartDate !== 'undefined' &&
      typeof this.campaign.redemptionEndDate !== 'undefined' &&

      typeof this.campaign.flagOpenRedemptionPeriod !== 'undefined' &&
      typeof this.campaign.flagAllSelectedChannels !== 'undefined' &&
      typeof this.campaign.flagOnlyCardHolder !== 'undefined' &&
      typeof this.campaign.flagOnlyLoyaltyCard !== 'undefined' &&

      this.errors.length == 0
    );
  }

  ngOnDestroy(){
    let channelCodes: string[] = [];
    this.priorityList.forEach(priority => channelCodes.push(priority.value.toString()));
    /* this.channels.map(channel => {
      if (channelCodes.indexOf(channel.value) == -1) {
        channelCodes.push(channel.value);
      }
    }); */
    this.campaign.channelCodeList = channelCodes.join();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-2/campaign-step-2.component.ts